<div class="zuper-vertical-navigation-wrapper">

    <!-- Header -->
    <div class="zuper-vertical-navigation-header">
        <ng-content select="[zuperVerticalNavigationHeader]"></ng-content>
    </div>

    <!-- Content -->
    <div
        class="zuper-vertical-navigation-content"
        zuperScrollbar
        [zuperScrollbarOptions]="{wheelPropagation: inner, suppressScrollX: true}"
        #navigationContent>

        <!-- Content header -->
        <div class="zuper-vertical-navigation-content-header">
            <ng-content select="[zuperVerticalNavigationContentHeader]"></ng-content>
        </div>

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="((item.hidden && !item.hidden) || !item.hidden)">

                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside'">
                    <zuper-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name"
                        [activeItemId]="activeAsideItemId"
                        [autoCollapse]="autoCollapse"
                        [skipChildren]="true"
                        id="{{item.id}}"
                        (mouseenter)="toggleAside(item)" (mouseleave)="checkMousePosition($event)"></zuper-vertical-navigation-aside-item>
                </ng-container>

                <!-- Basic -->
                <ng-container *ngIf="item.type === 'basic' && (!item?.hideInProduction || !env?.production)">
                    <zuper-vertical-navigation-basic-item
                        [item]="item"
                        [name]="name" (mouseenter)="closeAside();"></zuper-vertical-navigation-basic-item>
                </ng-container>

                <!-- Collapsable -->
                <ng-container *ngIf="item.type === 'collapsable'">
                    <zuper-vertical-navigation-collapsable-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="autoCollapse"></zuper-vertical-navigation-collapsable-item>
                </ng-container>

                <!-- Divider -->
                <ng-container *ngIf="item.type === 'divider'">
                    <zuper-vertical-navigation-divider-item
                        [item]="item"
                        [name]="name"></zuper-vertical-navigation-divider-item>
                </ng-container>

                <!-- Group -->
                <ng-container *ngIf="item.type === 'group'">
                    <zuper-vertical-navigation-group-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="autoCollapse"></zuper-vertical-navigation-group-item>
                </ng-container>

                <!-- Spacer -->
                <ng-container *ngIf="item.type === 'spacer'">
                    <zuper-vertical-navigation-spacer-item
                        [item]="item"
                        [name]="name"></zuper-vertical-navigation-spacer-item>
                </ng-container>

            </ng-container>

        </ng-container>

        <!-- Content footer -->
        <div class="zuper-vertical-navigation-content-footer">
            <ng-content select="[zuperVerticalNavigationContentFooter]"></ng-content>
        </div>

    </div>

    <!-- Footer -->
    <div class="zuper-vertical-navigation-footer">
        <ng-content select="[zuperVerticalNavigationFooter]"></ng-content>
    </div>

</div>

<!-- Aside -->
<div [hidden]="!activeAsideItemId">
    <div id="zuper-vertical-navigation-aside" [ngStyle]="setStyleForAside()"
        (mouseleave)="toggleAsideItemActive($event)"
        class="zuper-vertical-navigation-aside-wrapper shadow border overflow-hidden"
        zuperScrollbar
        [zuperScrollbarOptions]="{wheelPropagation: false, suppressScrollX: true, suppressScrollY: true}"
        [@fadeInLeft]="position === 'left'"
        [@fadeInRight]="position === 'right'"
        [@fadeOutLeft]="position === 'left'"
        [@fadeOutRight]="position === 'right'">

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="((item.hidden && !item.hidden) || !item.hidden)">

                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside' && item.id === activeAsideItemId">
                    <zuper-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="autoCollapse"></zuper-vertical-navigation-aside-item>
                </ng-container>

            </ng-container>

        </ng-container>

    </div>
</div>
